import { useState } from "react";
import styled from "styled-components";
import CloseBtn from "../../../../assets/icons/x-close.svg";
import mandatoryImage from "../../../../assets/images/orange-check-circle.png";
import nonMandatoryImage from "../../../../assets/images/xbox.png";
import recommended from "../../../../assets/images/blue-check-circle.png";

// #region SCOPED CSS
const StyledPage = styled.div`
    .items-panel,
    .items-panel * {
        box-sizing: border-box;
    }
    .items-panel {
        background: var(--backgrounds-and-lines-n-500, #141922);
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        height: 100dvh;
        width: 360px;
        position: fixed;
        z-index: 9999;
        right: 0px;
        top: 0px;
    }
    .frame-313273 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        overflow: hidden;
    }
    .frame-313271 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-end;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313329 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .settings-01 {
        opacity: 0;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
    }
    .header-fields {
        color: var(--buttons-all-platforms-gray-100, #d1d1d1);
        text-align: center;
        font-family: var(--heading-3-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-3-font-size, 20px);
        font-weight: var(--heading-3-font-weight, 400);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .x-close {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
        cursor: pointer;
    }
    .line-3 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-400, #1e2631);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-313276 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        overflow: hidden;
    }
    .frame-313333 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .tabs-main-window {
        padding: 4px 0px 2px 0px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313332 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-3133323 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .products-list {
        text-align: center;
        font-family: var(--label-small-uppercase-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .products-list33 {
        text-align: center;
        font-family: var(--label-small-uppercase-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .products-list2 {
        color: var(--text-and-icons-blue-500, #00aeef);
        text-align: center;
        font-family: var(--label-small-uppercase-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 10px;
        border-bottom: 1px solid;
        cursor: pointer;
    }
    .products-list23 {
        color: var(--text-and-icons-blue-500, #00aeef);
        text-align: center;
        font-family: var(--label-small-uppercase-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 10px;
        border-bottom: 1px solid;
        cursor: pointer;
    }
    .line-5 {
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
        overflow: visible;
    }
    .linked-products {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-family: var(--label-small-uppercase-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .linked-products2 {
        color: var(--text-and-icons-blue-500, #00aeef);
        text-align: center;
        font-family: var(--label-small-uppercase-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 10px;
        border-bottom: 1px solid;
        cursor: pointer;
    }
    .frame-1000011397 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        overflow: hidden;
    }
    .frame-1000011460 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .checkbox-label {
        padding: 8px 0px 8px 0px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .check-circle {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .gtin {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .check-circle2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .mandatory-2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .check-circle3 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .mandatory-3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .checkbox {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
    }
    .rectangle-1 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 8px;
        border-style: solid;
        border-color: var(--text-and-icons-gray-300, #4f5b6d);
        border-width: 1px;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .x-close2 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .mandatory-4 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .x-close3 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .mandatory-5 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .x-close4 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .mandatory-6 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .x-close5 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .mandatory-7 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .x-close6 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .mandatory-8 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .x-close7 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .mandatory-9 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .x-close8 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .mandatory-10 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .x-close9 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .mandatory-11 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .x-close10 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .mandatory-12 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .rectangle-6 {
        background: var(--backgrounds-and-lines-n-200, #262e3e);
        border-radius: 500px;
        flex-shrink: 0;
        width: 3px;
        height: 120px;
        position: absolute;
        left: 353px;
        top: 140px;
    }
`;
// #endregion

const ApiPageSidePanel = ({ setShowApiPageSidePanel = () => {}, selectedCategory }) => {
    // #region STATES
    const [activeTab, setActiveTab] = useState("mandatory");
    // #endregion

    // #region METHODS
    const getHeadingByCategory = category => {
        let heading;
        if (category === "headers") {
            heading = "Header Fields";
        } else if (category === "params") {
            heading = "Params Fields";
        } else if (category === "body") {
            heading = "Body Fields";
        } else if (category === "returnFields") {
            heading = "Return Fields";
        }
        return { heading };
    };

    const { heading } = getHeadingByCategory(selectedCategory?.category);
    // #endregion
    return (
        <StyledPage className="frame-panel">
            <div className="items-panel">
                <div className="frame-313273">
                    <div className="frame-313271">
                        <div className="frame-313329">
                            <div className="header-fields">{heading}</div>
                            <img
                                className="x-close"
                                src={CloseBtn}
                                alt=""
                                onClick={() => setShowApiPageSidePanel(false)}
                            />
                        </div>
                    </div>
                    <div className="line-3"></div>
                    <div className="frame-313276">
                        <div className="frame-313333">
                            <div className="tabs-main-window">
                                <div
                                    className={`frame-313332 ${activeTab === "mandatory" ? "active-tab" : ""}`}
                                    onClick={() => setActiveTab("mandatory")}>
                                    <div className={activeTab === "mandatory" ? "products-list2" : "products-list"}>
                                        MANDATORY
                                    </div>
                                </div>
                                <div className="frame-3133323">
                                    <div
                                        onClick={() => setActiveTab("recommended")}
                                        className={activeTab === "recommended" ? "products-list23" : "products-list33"}>
                                        RECOMMENDED
                                    </div>
                                </div>
                            </div>
                            {activeTab === "mandatory" && (
                                <>
                                    {selectedCategory?.fields?.mandatoryFieldsToShow?.map((item, index) => {
                                        return (
                                            <div className="frame-1000011397" key={index}>
                                                <div className="checkbox-label">
                                                    <img
                                                        className="check-circle"
                                                        src={item?.selected ? mandatoryImage : nonMandatoryImage}
                                                        alt=""
                                                    />
                                                    <div className="gtin">{item?.value}</div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            )}
                            {activeTab === "recommended" && (
                                <>
                                    {selectedCategory?.fields?.recommendedFieldsToShow?.map((item, index) => {
                                        return (
                                            <div className="frame-1000011397" key={index}>
                                                <div className="checkbox-label">
                                                    <img
                                                        className="check-circle"
                                                        src={item?.selected ? recommended : nonMandatoryImage}
                                                        alt=""
                                                    />
                                                    <div className="gtin">{item?.value}</div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="rectangle-6"></div>
            </div>
        </StyledPage>
    );
};

export default ApiPageSidePanel;
